module.exports = __webpack_public_path__ + "img/jiaoyu_shanxishifan_suoluetu.9ccb6d84.png";